import { useEffect } from "react";

const useControlKeys = ({
    onSave,
    onSearch,
    onEscape,
    onEnter,
    onNew,
    onPrint,
}) => {

    useEffect(() => {

        const handleKeyDown = (event) => {

            // Ctrl + S
            if (event.ctrlKey && event.key.toLowerCase() === "s") {
                event.preventDefault();
                onSave?.();
            }

            // Ctrl + F
            if (event.ctrlKey && event.key.toLowerCase() === "f") {
                event.preventDefault();
                onSearch?.();
            }

            // Escape
            if (event.key === "Escape") {
                onEscape?.();
            }

            // Enter
            if (event.key === "Enter") {
                onEnter?.();
            }

            // Ctrl + N
            if (event.ctrlKey && event.key.toLowerCase() === "n") {
                event.preventDefault();
                onNew?.();
            }

            // Ctrl + P
            if (event.ctrlKey && event.key.toLowerCase() === "p") {
                event.preventDefault();
                onPrint?.();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };

    }, [
        onSave,
        onSearch,
        onEscape,
        onEnter,
        onNew
    ]);
};

export default useControlKeys;